import React, { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { AdminReportingLocationEditContainer } from '@/components/Organization/Locations/Admin/AdminReportingLocationEditContainer';
import { PageTitle } from '@/components/common/PageTitle/PageTitle';
import { RouteContentWrapper } from '../../styles';

export const ReportingLocationEditRoute = () => {
    const { id } = useParams<{ id: string }>();
    const location = useLocation();
    const organizationId = (location.state as { organizationId?: number } | null)?.organizationId ?? null;
    const [locationName, setLocationName] = useState<string | null>(null);

    return (
        <RouteContentWrapper>
            <PageTitle title={locationName ? `Edit Reporting for ${locationName}` : 'Edit Location Reporting'} />
            <AdminReportingLocationEditContainer
                locationId={parseInt(id!)}
                organizationId={organizationId}
                onLocationNameLoaded={setLocationName}
            />
        </RouteContentWrapper>
    );
};
